export type KVPlaneIntersectionJSON = {
  planeIntersectionId: string
  planeIntersectionSegments: {
    startPosition: {
      x: number
      y: number
      z: number
    }
    endPosition: {
      x: number
      y: number
      z: number
    }
  }[]
  planeIntersectionLabel: string
  planeIntersectionVisible: boolean
}

export class KVPlaneIntersection {
  id: string
  planeIntersectionSegments: {
    startPosition: {
      x: number
      y: number
      z: number
    }
    endPosition: {
      x: number
      y: number
      z: number
    }
  }[]
  planeIntersectionLabel: string
  planeIntersectionVisible: boolean

  constructor(id: string) {
    this.id = id
    this.planeIntersectionSegments = []
    this.planeIntersectionLabel = 'Plane Intersection'
    this.planeIntersectionVisible = true
  }

  static fromJSON(json: KVPlaneIntersectionJSON): KVPlaneIntersection {
    const planeIntersection = new KVPlaneIntersection(json.planeIntersectionId)
    if (json.planeIntersectionSegments) {
      planeIntersection.planeIntersectionSegments =
        json.planeIntersectionSegments
    }
    planeIntersection.planeIntersectionLabel =
      json.planeIntersectionLabel || 'Plane Intersection'
    planeIntersection.planeIntersectionVisible =
      json.planeIntersectionVisible ?? true
    return planeIntersection
  }

  static toJSON(
    planeIntersection: KVPlaneIntersection
  ): KVPlaneIntersectionJSON {
    return {
      planeIntersectionId: planeIntersection.id,
      planeIntersectionSegments: planeIntersection.planeIntersectionSegments,
      planeIntersectionLabel: planeIntersection.planeIntersectionLabel,
      planeIntersectionVisible: planeIntersection.planeIntersectionVisible,
    }
  }
}
